<template>
    <Header />
    <div class="home">
        <img class="logo" alt="Vue logo" src="@lib/frontend/assets/new.png">
        <h1>Welcome to the Prebooking Overview tool </h1>
    </div>
</template>

<script>
// @ is an alias to /src
import Header from '../components/Header.vue'
import { inject } from "vue";

export default {
    name: 'Homeview',
    components: {
        Header,
    },
    setup() {
        const { profile } = inject('user')
        return {
            profile
        }
    },
    watch: {
        profile: {
            handler(newVal) {
                if (newVal?.role?.name === 'LFO') {
                    this.$router.push({ name: 'LFO_Prize_Wheel' });
                }
            },
            immediate: true
        }
    },
    mounted() {
        let user = localStorage.getItem('user-info');
        if (!user) {
            this.$router.push({
                name: 'home'
            })
        }
    }
}
</script>

<style>
.logo {
    height: 180px;
    margin-top: 150px;
}

.content-container {
    background-color: black;
    color: white;
    font-size: 40px;
    margin-top: 500px;
    height: 900px;
    width: auto;
}

.city-links-wrap {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    color: white;
}

.city-link {
    width: calc(25% - 10px);
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 20px;
    font-size: 30px;
}

.city-mail {
    color: white;
}

.city-name {
    font-size: 24px;
    font-weight: bold;
    text-decoration: none;
    color: #333;
    margin-bottom: 5px;
}

.city-name:hover {
    text-decoration: underline;
}

.city-tel {
    font-size: 16px;
    text-decoration: none;
    color: #666;
}

.city-tel:hover {
    color: #333;
    text-decoration: underline;
}

.follow-us {
    display: flex;
    align-items: center;
    margin-top: 100px;
    margin-left: 900px;
}

.social-link-wrap {
    display: flex;
}

.social-link {
    margin-right: 10px;

}

.social-link img {
    height: 30px;
    width: auto;
}

.insidelogo {
    margin-left: 500px;
    max-height: 100px;
    max-width: auto;
    margin-top: -300px;
}

nav a {
    color: white;

}
</style>
